export const getFriendlyErrorMessage = (error) => {
    const message = error?.message || (typeof error === 'string' ? error : 'An error occurred');

    if (message.includes("EntryFindMap.entityHash_contentTypeId_workspaceId")) {
        return "You cannot have the same values for findable fields.";
    }

    return message;
};
